import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'PageHeading',
    mixins: [
        glSlotsMixin
    ],
    inject: {
        injectedHeadingTag: {
            from: 'panelHeadingTag',
            default: 'h1'
        }
    },
    props: {
        heading: {
            type: String,
            required: false,
            default: null
        },
        headingTag: {
            type: String,
            required: false,
            default: null,
            validator: (value)=>value === null || [
                    'h1',
                    'h2'
                ].includes(value)
        },
        inlineActions: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        computedHeadingTag () {
            return this.headingTag ?? this.injectedHeadingTag;
        }
    }
};
